import CommentButton from 'desktop/components/comment_button';
import CommentReply from 'desktop/components/comment_reply';
import ShowMoreContent from 'shared/show_more_content';
import $ from 'jquery';
import "timeago/jquery.timeago";

export default class LatestCommentsWatchPage {
  constructor() {
    this.$formContainer = $("#comments__form-container");
  }

  init() {
    this.setupCommentButton();
  }

  setupCommentButton() {
    new ShowMoreContent('.js-comment-container', '.truncate .read-more-comment', '.hidden'); // comments
    var commentButton = $('.video-engagement__comment-button-trigger[data-component="CommentButton"]');
    if(commentButton) {
      commentButton = new CommentButton({$element: commentButton});
      commentButton.init();
    }
    var commentReply = new CommentReply();
    commentReply.init();
    $("span.publish-date").timeago();
  }
}
